export class ImobiliariaAtualizarRequest {
  nomeFantasia: string;
  razaoSocial: string;
  email: string;
  telefone: string;
  cep: string;
  endereco: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;

  constructor(p: any) {
    this.nomeFantasia = p.nomeFantasia ?? null;
    this.razaoSocial = p.razaoSocial ?? null;
    this.email = p.email ?? null;
    this.telefone = p.telefone ?? null;
    this.cep = p.cep ?? null;
    this.endereco = p.endereco ?? null;
    this.numero = p.numero ?? null;
    this.complemento = p.complemento ?? null;
    this.bairro = p.bairro ?? null;
    this.cidade = p.cidade ?? null;
    this.estado = p.estado ?? null;
  }
}
